// extracted by mini-css-extract-plugin
module.exports = {"tutorialSkipper":"TutorialSkipper_tutorialSkipper__33_Co","content":"TutorialSkipper_content__1PCRG"};